import isFunction from 'lodash/isFunction';
import { type MutableRefObject, useRef } from 'react';

const uninitializedState = Symbol('Uninitialized state');

export const useLazyRef = <T,>(
  initialValue: T | (() => T),
): MutableRefObject<T> => {
  const ref = useRef<T | typeof uninitializedState>(uninitializedState);
  if (ref.current === uninitializedState) {
    ref.current = isFunction(initialValue) ? initialValue() : initialValue;
  }
  // assertion to exclude uninitialized state from ref type
  return ref as MutableRefObject<T>;
};
